import { LoaderIcon } from '@/components/atoms/icons/LoaderIcon';
import { UI_PRIMITIVES } from '@/core/constants/uiColors';
import {
  ADHA_UAE_PASS_CALLBACK_PATH,
  ADHA_UAE_PASS_WELCOME_PATH,
} from '@/modules/auth/constants/adhaUaePass';
import { adhaUaePassService } from '@/modules/auth/services/adhaUaePassService';
import { useNavigationContainerRef, useRouter } from 'expo-router';
import React, { useEffect, useRef, useState } from 'react';
import { StyleSheet, View } from 'react-native';

/**
 * ADHA web UAE Pass OAuth callback (`/uae-pass`).
 * Overlay + white in-progress icon; stash params; SPA-navigate to `/welcome`.
 */
function isUaePassCallbackPath(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const path = window.location.pathname.replace(/\/$/, '') || '/';
  return path === ADHA_UAE_PASS_CALLBACK_PATH;
}

function hasOAuthCallbackParams(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const params = new URLSearchParams(window.location.search);
  return Boolean(params.get('code') || params.get('error') || params.get('state'));
}

export default function AdhaUaePassCallbackWebRoute() {
  const router = useRouter();
  const navigationRef = useNavigationContainerRef();
  const hasHandledRef = useRef(false);
  const [isNavReady, setIsNavReady] = useState(false);

  useEffect(() => {
    if (navigationRef.isReady()) {
      setIsNavReady(true);
      return;
    }

    const intervalId = window.setInterval(() => {
      if (navigationRef.isReady()) {
        setIsNavReady(true);
        window.clearInterval(intervalId);
      }
    }, 16);

    return () => window.clearInterval(intervalId);
  }, [navigationRef]);

  useEffect(() => {
    if (!isNavReady || hasHandledRef.current) {
      return;
    }
    if (!isUaePassCallbackPath() || !hasOAuthCallbackParams()) {
      return;
    }

    hasHandledRef.current = true;
    adhaUaePassService.stashRawCallbackFromWindow();

    const frameId = requestAnimationFrame(() => {
      router.replace(ADHA_UAE_PASS_WELCOME_PATH);
    });

    return () => cancelAnimationFrame(frameId);
  }, [isNavReady, router]);

  return (
    <View style={styles.root}>
      <LoaderIcon size={48} color="#FFFFFF" />
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: UI_PRIMITIVES.overlayBackdrop,
  },
});
